import $ from 'jquery'
import 'velocity-animate/velocity'
import 'velocity-animate/velocity.ui'

$.Velocity.defaults.duration = 300
$.Velocity.defaults.easing = 'easeOutQuad'

$.extend($.Velocity.Easings, {
  Back(p) {
    return p * p * (3 * p - 2)
  },
  Bounce(p) {
    let pow2
    let bounce = 4

    // eslint-disable-next-line no-cond-assign, no-plusplus
    while (p < ((pow2 = 2 ** --bounce) - 1) / 11) {
      // eslint-disable-next-line no-continue
      continue
    }
    return 1 / 4 ** 3 - bounce - 7.5625 * ((pow2 * 3 - 2) / 22 - p) ** 2
  },
})

$.each(['Back', 'Bounce'], (index, easeInName) => {
  const easeIn = $.Velocity.Easings[easeInName]

  $.Velocity.Easings[`easeIn${easeInName}`] = easeIn

  $.Velocity.Easings[`easeOut${easeInName}`] = p => 1 - easeIn(1 - p)

  $.Velocity.Easings[`easeInOut${easeInName}`] = p => {
    if (p < 0.5) {
      return easeIn(p * 2) / 2
    } else {
      return 1 - easeIn(p * -2 + 2) / 2
    }
  }
})

$.Velocity.RegisterEffect('everlane.transition.collapse', {
  calls: [
    [
      {
        height: [0, () => $(this).css('height')],
        opacity: [0, () => $(this).css('opacity')],
      },
    ],
  ],
})
